import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleDAO } from '../../../core/services/dao/roleDAO';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { ApiHelper } from '../../../core/services/apiHelper';
import { AdminAccess } from '../../shared/accessAdmin';
import { ConstantMan } from '../../../core/services/constantMan';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit {
  charterParams = { los: 'charter' };
  unapprovedParams = { status: 'unapproved' };
  isMobile = false;
  isLoading = false;

  constructor(
    private router: Router,
    private roleDAO: RoleDAO,
    private userDAO: UserDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
    this.isMobile = window && window.screen && window.screen.width < 960;
  }

  ngOnInit() {}

  routerEventClick(): void {
    this.isLoading = true;
  }
}
